import routes from '@app/routes';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import useTrackEvent from '../analytics/useTrackEvent';

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);

const router = sentryCreateBrowserRouter(routes);

const WidgetRouter = () => {
  const { trackEvent } = useTrackEvent();

  useEffect(() => {
    router.subscribe(state => {
      trackEvent('pageview', {
        page: state.location.pathname,
        state: state.location.search
      });
    });
  });

  useEffect(() => {
    trackEvent('pageview', { page: location.pathname });
  }, [location]);

  return <RouterProvider router={router} />;
};

export default WidgetRouter;
